import React from 'react'

import config from '../config.js'

import { Link } from 'react-router-dom'

class ListCookbook extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    //= ({ baseUrl, theme, cookbook }) => {

    let cookbookImage = ''
    let cookbookImageUrl = config.baseUrl + '/assets/img/generic-cookbook-dark.png'

    if (this.props.theme !== 'light') {
      cookbookImageUrl = config.baseUrl + '/assets/img/generic-cookbook-dark.png'
    }

    if (
      this.props.cookbook.imageUrl !== null &&
      this.props.cookbook.imageUrl !== undefined &&
      this.props.cookbook.imageUrl !== ''
    ) {
      if (this.props.cookbook.imageUrl.indexOf('lh3.googleusercontent.com') !== -1) {
        cookbookImageUrl = this.props.cookbook.imageUrl + '=w182-h250'
      } else cookbookImageUrl = this.props.cookbook.imageUrl
    }

    cookbookImage = (
      <img
        className="cookbook__img"
        src={cookbookImageUrl}
        alt={this.props.cookbook.title + ' Cover'}
      />
    )

    return (
      <li className="cookbook">
        {cookbookImage}
        <h3 className="cookbook__title">
          <Link
            className="cookbook__link"
            to={this.props.baseUrl + '/' + this.props.cookbook.identifier}
          >
            {this.props.cookbook.title}
          </Link>
        </h3>
      </li>
    )
  }
}

export default ListCookbook



// WEBPACK FOOTER //
// ./src/Components/ListCookbook.js